var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-box"},[_c('edit-date',{attrs:{"text":"选择地区"}}),_vm._v(" "),_c('div',{staticClass:"address-text"},[_vm._v("详细地址")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }